"use client";

import { generateAmortizationSchedule } from "@/utils/amortization";
import { useMemo } from "react";
import { useRefinanceContext } from "@/context/RefinanceContext";

const toCurrency = (num: number) => "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

const CurrentLoanTable = () => {
    const { currentLoan } = useRefinanceContext();

    const schedule = useMemo(
        () =>
            generateAmortizationSchedule(
                currentLoan.amount || 0,
                currentLoan.interestRate || 0,
                currentLoan.termYears || 0,
            ),
        [currentLoan],
    );

    return (
        <div className="overflow-x-auto mt-10 2xl:pb-4 2xl:w-[866px] 2xl:mx-auto">
            <h3 className="text-xl font-bold mb-4 text-center text-[#212459]">Current Loan</h3>
            <table className="w-full 2xl:w-[866px] table-auto border border-gray-300 border-collapse bg-white shadow">
                <thead className="bg-blue text-white">
                    <tr>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Month</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Payment</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Balance</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Principal</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Interest</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Cum. Intr.</th>
                    </tr>
                </thead>
                <tbody>
                    {schedule.map((row) => (
                        <tr key={row.month} className="odd:bg-[#f6f9ff] even:bg-white text-center">
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{row.month}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{toCurrency(row.payment)}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{toCurrency(row.balance)}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">
                                {toCurrency(row.principal)}
                            </td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{toCurrency(row.interest)}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">
                                {toCurrency(row.cumulativeInterest)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CurrentLoanTable;
